import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik, Form } from "formik";
import { registerValidationSchema } from "../../validationSchema/ValidationSchema";
import Button from "../../components/Button";
import TextInput from "../../components/TextInput";
import Phone from "../../components/Phone";
import PasswordInput from "../../components/PasswordInput";
import Dropdown from "../../components/Dropdown";
import Lable from "../../components/Lable";
import { useDispatch, useSelector } from "react-redux";
import { storeRegister } from "../../store/slices/storeSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoaderContext from "../../components/loader";
import { user_role } from "../../config/apiConfig";
import masterApi from "../../apis/master.api";
import { useFetchAll } from "../../custom/FetchApiHook";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../firebase";
import AuthApi from "../../apis/auth.apis";
import ArticleModel from "../Account/ArticleModel";
import { ArticlesApi } from "../../apis/profile.apis";
import GoogleMapsView from "../../components/GoogleMap/GoogleMapsView";

const Register = () => {
  const [mapLocation, setMapLocation] = useState({
    lat: 5.5571096,
    lng: -0.2012376,
  });

  const GHANA_COUNTRY_ID = "66cd6e58bb9a967736a7f72b";
  const dispatch = useDispatch();
  const { handleLoading } = useContext(LoaderContext);
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.store);
  const [countryId] = useState(GHANA_COUNTRY_ID);
  const [isApplied, setIsApplied] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [isArticleOpen, setIsArticleOpen] = useState(false);
  const [articleData, setArticleData] = useState("");
  const [articleTitle, setArticleTitle] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);

  const [emailVerified, setEmailVerified] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);

  const [emailOtp, setEmailOtp] = useState("");
  const [phoneOtp, setPhoneOtp] = useState("");

  const [emailTimer, setEmailTimer] = useState(0);
  const [phoneTimer, setPhoneTimer] = useState(0);
  const cityData = useFetchAll(
    () => countryId && masterApi.getAllCity(countryId),
  );
  const BuisnessTypeData = useFetchAll(() => masterApi.getAllBuisnessType());
  const { theme } = useSelector((state) => state.theme);

  useEffect(() => {
    handleLoading(loading);
  }, [handleLoading, loading]);

  useEffect(() => {
    if (emailTimer <= 0) return undefined;

    const timer = setInterval(() => {
      setEmailTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [emailTimer]);

  useEffect(() => {
    if (phoneTimer <= 0) return undefined;

    const timer = setInterval(() => {
      setPhoneTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [phoneTimer]);

  const googleRegister = (firebaseUser, defaultCountry) => {
    const { displayName, phoneNumber, accessToken } = firebaseUser;
    const [first_name, last_name] = displayName
      ? displayName.split(" ")
      : ["", ""];
    return {
      first_name,
      token: accessToken,
      provider: true,
      last_name,
      email: "",
      phone_number: phoneNumber || "",
      user_role: user_role.vendor,
      country: defaultCountry,
      password: "",
      referral_code: "",
      ghana_id: "", // Added for Google register (empty by default)
    };
  };

  const signUpWithGoogle = async (setValues) => {
    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;
      setValues(googleRegister(user, GHANA_COUNTRY_ID));
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      alert("Google Sign-In failed. Please try again.");
    }
  };

  const initialValues = {
    email: "",
    user_role: user_role.vendor,
    first_name: "",
    last_name: "",
    phone_number: "",
    address: "",
    gender: "",
    profile_image: null,
    country: GHANA_COUNTRY_ID,
    city: null,
    delivery_business: null,
    latitude: "",
    longitude: "",
    referral_code: "",
    password: "",
    ghana_id: "", // <-- Added ghana_id here
  };

  const city = cityData.value.data
    ? cityData.value.data.map((c, i) => {
        c.label = c.name;
        c.value = c._id;
        return c;
      })
    : [];

  const deliveryBusiness = BuisnessTypeData.value.data
    ? BuisnessTypeData.value.data.map((c, i) => {
        c.label = c.name;
        c.value = c._id;
        return c;
      })
    : [];

  const sendEmailOtp = async (email) => {
    try {
      await AuthApi.generateOtp({
        email: email,
        phone_number: "",
        purpose: "register",
      });
      toast.success("OTP sent to email");
      setEmailOtpSent(true);
      setEmailVerified(false);
      setEmailOtp("");
      setEmailTimer(60);
    } catch (err) {
      toast.error(err.response?.data?.message);
    }
  };

  const verifyEmailOtp = async (email) => {
    try {
      const res = await AuthApi.verifyOtp({
        email: email,
        phone_number: "",
        otp: emailOtp,
      });

      if (res.status === 200) {
        toast.success("Email verified");
        setEmailVerified(true);
      }
    } catch (err) {
      toast.error("Invalid OTP");
    }
  };

  const sendPhoneOtp = async (phone) => {
    try {
      await AuthApi.generateOtp({
        email: "",
        phone_number: phone,
        purpose: "register",
      });
      toast.success("OTP sent to phone");
      setPhoneOtpSent(true);
      setPhoneVerified(false);
      setPhoneOtp("");
      setPhoneTimer(60);
    } catch (err) {
      toast.error(err.response?.data?.message);
    }
  };

  const verifyPhoneOtp = async (phone) => {
    try {
      const res = await AuthApi.verifyOtp({
        email: "",
        phone_number: phone,
        otp: phoneOtp,
      });

      if (res.status === 200) {
        toast.success("Phone verified");
        setPhoneVerified(true);
      }
    } catch (err) {
      toast.error("Invalid OTP");
    }
  };

  const resetRegistrationState = () => {
    setEmailOtpSent(false);
    setPhoneOtpSent(false);
    setEmailVerified(false);
    setPhoneVerified(false);
    setEmailOtp("");
    setPhoneOtp("");
    setEmailTimer(0);
    setPhoneTimer(0);
    setReferralCode("");
    setIsApplied(false);
    setMapLocation({
      lat: 5.5571096,
      lng: -0.2012376,
    });
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log("FINAL FORM VALUES:", values);
    if (!emailVerified && !phoneVerified) {
      toast.error(
        "Please verify any one from email and phone number before registering.",
      );
      return;
    }

    try {
      await dispatch(storeRegister(values)).unwrap();
      resetForm();
      resetRegistrationState();
      navigate("/", { replace: true });
      toast.success("Registration successful!");
    } catch (err) {
      console.log(err);
    }
  };

  const handleReferral = async (values) => {
    console.log("Applying referral code:", values.referral_code);
    const payload = {
      referral_code: values.referral_code,
    };
    console.log(values);
    handleLoading(true);
    try {
      const res = await AuthApi.referralCode(payload);
      setReferralCode(values.referral_code);
      toast.success("Referral code added successfully");
      setIsApplied(true);
      console.log(res.data);
    } catch (err) {
      console.log(err.response?.data?.message);
      toast.error(err.response?.data?.message);
    } finally {
      handleLoading(false);
    }
  };

  const handleDeleteCode = () => {
    setReferralCode("");
    setIsApplied(false);
  };

  useEffect(() => {
    cityData.fetchAllData();
  }, [countryId]);

  const handleArticle = async (type) => {
    setIsArticleOpen(true);
    setArticleTitle(type);
    handleLoading(true);

    try {
      const data = await ArticlesApi.getArticlesDetails();
      const articleContent =
        type === "TNC"
          ? data.data.data[0].storeTermsAndConditions
          : data.data.data[0].storePrivacyPolicy;

      setArticleData(articleContent);
    } catch (error) {
      console.error("Error fetching article data:", error);
      toast.error(error.message);
    } finally {
      handleLoading(false);
    }
  };

  const handleClose = () => {
    setIsArticleOpen(false);
    setArticleData("");
  };

  const handleEmailChange = (event, formikHandleChange) => {
    formikHandleChange(event);
    setEmailOtpSent(false);
    setEmailVerified(false);
    setEmailOtp("");
    setEmailTimer(0);
  };

  const handlePhoneChange = () => {
    setPhoneOtpSent(false);
    setPhoneVerified(false);
    setPhoneOtp("");
    setPhoneTimer(0);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={registerValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ handleChange, setFieldValue, values, setValues }) => (
        <>
          <div
            className={`flex flex-col items-center justify-center gap-5 my-10  ${
              theme === "light" ? "" : " text-darkSecondary"
            }`}
          >
            <div className="flex gap-5 items-center justify-center ">
              <span className=" flex items-center justify-center gap-3 cursor-pointer w-full rounded-full bg-[#efeeee]  p-2 shadow-2xl">
                <FcGoogle
                  className="text-4xl cursor-pointer"
                  onClick={() => signUpWithGoogle(setValues)}
                />
              </span>
             
            </div>
            <span
              className={` ${
                theme === "light" ? "text-primaryColor" : " text-darkSecondary"
              }`}
            >
              Or
            </span>
          </div>
          <Form className="mt-12">
            <div
              className={`gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3 ${
                theme === "light" ? "text-primaryColor" : " text-darkSecondary"
              }`}
            >
              <Lable lable="Store Name" />
              <div>
                <TextInput
                  name="first_name"
                  type="text"
                  placeholder="Store Name"
                  onChange={handleChange}
                  value={values.first_name}
                />
                <ErrorMessage
                  name="first_name"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="gap-3 grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="E-Mail" />
              <div>
                <div className="flex">
                  <TextInput
                    name="email"
                    type="email"
                    placeholder="E-mail"
                    onChange={(event) => handleEmailChange(event, handleChange)}
                    value={values.email}
                    disabled={emailVerified}
                  />

                  {!emailVerified ? (
                    <button
                      type="button"
                      className="bg-buttonColor text-white px-3 rounded-r-md text-sm whitespace-nowrap"
                      onClick={() => sendEmailOtp(values.email)}
                      disabled={!values.email || emailTimer > 0}
                    >
                      {emailTimer > 0 ? `Resend (${emailTimer}s)` : "Send OTP"}
                    </button>
                  ) : (
                    <div className="bg-green-500 text-white px-3 rounded-r-md text-sm flex items-center justify-center whitespace-nowrap">
                      ✔ Verified
                    </div>
                  )}
                </div>

                {emailOtpSent && !emailVerified && (
                  <div className="flex gap-2 mt-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                      className="border px-2 py-1 rounded w-full"
                    />
                    <button
                      type="button"
                      className="bg-green-500 text-white px-3 rounded"
                      onClick={() => verifyEmailOtp(values.email)}
                    >
                      Verify
                    </button>
                  </div>
                )}

                <ErrorMessage name="email" component="div" className="error" />
              </div>
            </div>

            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="City" />
              <div>
                <Dropdown
                  options={city}
                  name="city"
                  value={values.city}
                  handleOnchange={(v) => {
                    setFieldValue("city", v._id);

                    if (v.latitude && v.longitude) {
                      setMapLocation({
                        lat: Number(v.latitude),
                        lng: Number(v.longitude),
                      });
                      setFieldValue("latitude", v.latitude);
                      setFieldValue("longitude", v.longitude);
                    }
                  }}
                />
                <ErrorMessage name="city" component="div" className="error" />
              </div>
            </div>
            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Delivery Business" />
              <div>
                <Dropdown
                  options={deliveryBusiness}
                  name="delivery_business"
                  value={values.delivery_business}
                />
                <ErrorMessage
                  name="delivery_business"
                  component="div"
                  className="error"
                />
              </div>
            </div>

            <div className="gap-3 grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Phone" />
              <div>
                <div className="flex">
                  <Phone
                    value={values.phone_number}
                    name="phone_number"
                    onChange={handlePhoneChange}
                    disabled={phoneVerified}
                  />

                  {!phoneVerified ? (
                    <button
                      type="button"
                      className="bg-buttonColor text-white px-3 rounded-r-md text-sm whitespace-nowrap"
                      onClick={() => sendPhoneOtp(values.phone_number)}
                      disabled={!values.phone_number || phoneTimer > 0}
                    >
                      {phoneTimer > 0 ? `Resend (${phoneTimer}s)` : "Send OTP"}
                    </button>
                  ) : (
                    <div className="bg-green-500 text-white px-3 rounded-r-md text-sm flex items-center justify-center whitespace-nowrap">
                      ✔ Verified
                    </div>
                  )}
                </div>

                {phoneOtpSent && !phoneVerified && (
                  <div className="flex gap-2 mt-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={phoneOtp}
                      onChange={(e) => setPhoneOtp(e.target.value)}
                      className="border px-2 py-1 rounded w-full"
                    />
                    <button
                      type="button"
                      className="bg-green-500 text-white px-3 rounded"
                      onClick={() => verifyPhoneOtp(values.phone_number)}
                    >
                      Verify
                    </button>
                  </div>
                )}

                <ErrorMessage
                  name="phone_number"
                  component="div"
                  className="error"
                />
              </div>
            </div>

            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Password" />
              <div>
                <PasswordInput
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  value={values.password}
                  autoComplete
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="error"
                />
              </div>
            </div>

            {isApplied && (
              <div className="flex items-center justify-between bg-green-100 text-green800 p-2 rounded-md mb-3">
                <span>Referral Code: {referralCode}</span>
                <button
                  onClick={handleDeleteCode}
                  className="text-RedColor font-bold"
                >
                  x
                </button>
              </div>
            )}
            
            <GoogleMapsView
              lat={mapLocation.lat}
              lng={mapLocation.lng}
              address={values.address}
              onAddressChange={(nextAddress) =>
                setFieldValue("address", nextAddress)
              }
              getAddress={(address, latLng) => {
                console.log("MAP CLICK:", latLng);

                setFieldValue("latitude", latLng.lat);
                setFieldValue("longitude", latLng.lng);
                setMapLocation({
                  lat: latLng.lat,
                  lng: latLng.lng,
                });

                if (address) {
                  setFieldValue("address", address);
                }
              }}
            />
            <ErrorMessage name="address" component="div" className="error" />
            <div className="flex gap-2 mt-4 items-start">
              <input type="checkbox" className="mb-2" required />

              {/* Updated Label with clickable Terms and Privacy links */}
              <p
                className={`text-sm ${
                  theme === "light"
                    ? "text-primaryColor"
                    : " text-darkSecondary"
                }`}
              >
                I agree to the{" "}
                <span
                  className="text-buttonColor cursor-pointer hover:underline"
                  onClick={() => handleArticle("TNC")}
                >
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span
                  className="text-buttonColor cursor-pointer hover:underline"
                  onClick={() => handleArticle("PP")}
                >
                  Privacy Policy
                </span>
              </p>
            </div>

            <div className="mt-3">
              <Button
                text={"Signup"}
                type={"submit"}
              />
            </div>
          </Form>
          {isArticleOpen && (
            <ArticleModel
              data={articleData}
              title={
                articleTitle === "TNC"
                  ? "Terms and Conditions"
                  : "Privacy Policy"
              }
              onClose={handleClose}
            />
          )}
        </>
      )}
    </Formik>
  );
};

export default Register;
